import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IconHome, IconTool, IconCalendarEventFilled, IconUsers, IconCurrentLocation } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const Menu = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const [isPWA, setIsPWA] = useState(false);

    useEffect(() => {
        // Check if running as PWA
        const checkPWA = () => {
            const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
            setIsPWA(isStandalone);
        };
        checkPWA();
    }, []);

    return (
        <div className={`flex justify-evenly bg-[var(--light-color)] text-[var(--dark-color)] text-sm uppercase ${isPWA ? "pb-6" : ""}`}>
            <Link to="/" className={`flex items-center gap-2 h-10 px-4 py-2 border-t-4 ${location.pathname === "/" ? "border-[var(--dark-color)]" : "border-transparent"}`}>
                <IconHome stroke={1.5} className="w-6 h-auto" />
                <span className="hidden md:block transform -skew-x-12 font-bold">{t("menu.home")}</span>
            </Link>
            <Link to="/athletes" className={`flex items-center gap-2 h-10 px-4 py-2 border-t-4 ${location.pathname.startsWith("/athletes") ? "border-[var(--dark-color)]" : "border-transparent"}`}>
                <IconUsers stroke={1.5} className="w-6 h-auto" />
                <span className="hidden md:block transform -skew-x-12 font-bold">{t("menu.athletes")}</span>
            </Link>
            <Link to="/events" className={`flex items-center gap-2 h-10 px-4 py-2 border-t-4 ${location.pathname.startsWith("/events") ? "border-[var(--dark-color)]" : "border-transparent"}`}>
                <IconCalendarEventFilled stroke={1.5} className="w-6 h-auto" />
                <span className="hidden md:block transform -skew-x-12 font-bold">{t("menu.events")}</span>
            </Link>
            <Link to="/shooting" className={`flex items-center gap-2 h-10 px-4 py-2 border-t-4 ${location.pathname.startsWith("/shooting") ? "border-[var(--dark-color)]" : "border-transparent"}`}>
                <IconCurrentLocation stroke={1.5} className="w-6 h-auto" />
                <span className="hidden md:block transform -skew-x-12 font-bold">{t("menu.shootingRange")}</span>
            </Link>
            <Link to="/settings" className={`flex items-center gap-2 h-10 px-4 py-2 border-t-4 ${location.pathname.startsWith("/settings") ? "border-[var(--dark-color)]" : "border-transparent"}`}>
                <IconTool stroke={1.5} className="w-6 h-auto" />
                <span className="hidden md:block transform -skew-x-12 font-bold">{t("menu.settings")}</span>
            </Link>
        </div>
    );
};

export default Menu;
